import { render, staticRenderFns } from "./ModalCapacitacion.vue?vue&type=template&id=0e2079dd"
import script from "./ModalCapacitacion.vue?vue&type=script&lang=js"
export * from "./ModalCapacitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports